import { InjectionToken } from '@angular/core';

export const CHUNK_RELOAD_MARKER_KEY = 'ff-i18n-chunk-reload';

export interface ChunkLoadRecovery {
  hasReloadMarker(): boolean;
  setReloadMarker(): void;
  clearReloadMarker(): void;
  reload(): void;
}

export function isChunkLoadError(error: unknown): boolean {
  if (!error) {
    return false;
  }

  if (error instanceof Error) {
    if (error.name === 'ChunkLoadError') {
      return true;
    }

    if (/Loading chunk [\w-]+ failed/i.test(error.message)) {
      return true;
    }
  }

  const message = String((error as { message?: string })?.message ?? error);
  return /ChunkLoadError|Loading chunk [\w-]+ failed/i.test(message);
}

export function createBrowserChunkLoadRecovery(): ChunkLoadRecovery {
  return {
    hasReloadMarker(): boolean {
      try {
        return sessionStorage.getItem(CHUNK_RELOAD_MARKER_KEY) === '1';
      } catch {
        return false;
      }
    },
    setReloadMarker(): void {
      try {
        sessionStorage.setItem(CHUNK_RELOAD_MARKER_KEY, '1');
      } catch {
        // Ignore storage failures in restricted browser contexts.
      }
    },
    clearReloadMarker(): void {
      try {
        sessionStorage.removeItem(CHUNK_RELOAD_MARKER_KEY);
      } catch {
        // Ignore storage failures in restricted browser contexts.
      }
    },
    reload(): void {
      if (typeof window !== 'undefined') {
        window.location.reload();
      }
    },
  };
}

export const CHUNK_LOAD_RECOVERY = new InjectionToken<ChunkLoadRecovery>(
  'CHUNK_LOAD_RECOVERY',
);
